// import Head from 'next/head';
import { useSearch } from 'react-location';
import Footer from '../components/landing/Footer';
import Header from '../components/landing/Header2';
import MoreInfo from '../components/landing/MoreInfo2';
import TOSTerms from '../components/landing/TOSTerms2';
import { useOnlineHotlineAvailable } from '../modules/datastores/useEntryPoint';

/**
 * This is the TOS Page - its only for RAINN - diff people will have diff pages.
 */
const TOSPage: React.FC = () => {
  const query = useSearch();
  const messaging_service_key = query['messaging_service_key'] as string;
  const statusQuery = useOnlineHotlineAvailable(`${messaging_service_key}`);
  if (statusQuery.isLoading) {
    return;
  }
  return (
    <>
      <head>
        <title>Terms Of Service - Online Hotline</title>
      </head>
      <Header statusQuery={statusQuery} />
      <TOSTerms statusQuery={statusQuery} />
      <MoreInfo />
      <Footer site={'SARNCO'} statusQuery={statusQuery} />
    </>
  );
};

export default TOSPage;
